import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["aria-haspopup"]
const _hoisted_2 = {
  key: 0,
  class: "mr-1 truncate"
}
const _hoisted_3 = {
  class: "dropdown-menu",
  id: "dropdown-menu",
  role: "menu"
}
const _hoisted_4 = { class: "dropdown-content" }

import { ref, onMounted, onUnmounted } from 'vue'

import SvgIcon from '@/popup/components/shared/SvgIcon.vue'

type Props = {
  isOpen?: boolean
  selected?: string
  triggerClass?: string
  isOpenUp?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Dropdown',
  props: {
    isOpen: { type: Boolean },
    selected: { default: undefined },
    triggerClass: { default: '' },
    isOpenUp: { type: Boolean }
  },
  setup(__props: any) {

const dropdownRef = ref<HTMLElement>()



const onToggleDropdown = () => {
  dropdownRef.value?.classList.toggle('is-active')
}

const onCloseDropdown = () => {
  dropdownRef.value?.classList.remove('is-active')
}

onMounted(() => {
  window.addEventListener('click', onCloseDropdown, false)
})

onUnmounted(() => {
  window.removeEventListener('click', onCloseDropdown, false)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["dropdown", { 'is-active': _ctx.isOpen, 'is-open-up': _ctx.isOpenUp }]),
    role: "dropdown",
    ref_key: "dropdownRef",
    ref: dropdownRef
  }, [
    _createElementVNode("div", {
      class: "dropdown-trigger",
      onClick: _withModifiers(onToggleDropdown, ["stop"]),
      "data-testid": "dropdown"
    }, [
      _createElementVNode("button", {
        class: _normalizeClass(["button", _ctx.triggerClass]),
        "aria-haspopup": _ctx.isOpen,
        "aria-controls": "dropdown-menu"
      }, [
        (_ctx.selected)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.selected), 1 /* TEXT */))
          : _renderSlot(_ctx.$slots, "selected", { key: 1 }),
        _createVNode(SvgIcon, {
          name: "arrow-down-sm",
          color: "var(--neutral-20)"
        })
      ], 10 /* CLASS, PROPS */, _hoisted_1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ], 2 /* CLASS */))
}
}

})